"use client";

import { Icon } from "@cloai/uikit";
import Image from "next/image";
import { FC, useState } from "react";

import { cn } from "@/utils/cn";

/**
 * Пропсы для компонента изображения
 */
interface StorylineImageProps {
  /** URL изображения */
  src: string;
  /** Флаг видимости */
  isShow?: boolean;
}

/**
 * Компонент для отображения изображения сторилайна
 *
 * @description
 * Отображает изображение с эффектом размытия фона.
 * Поддерживает условное отображение через prop isShow.
 *
 * @example
 * ```tsx
 * <StorylineImage src="path/to/image.jpg" isShow={true} />
 * ```
 */
export const StorylineImage: FC<StorylineImageProps> = ({ src, isShow }) => {
  const [errorLoadingImage, setErrorLoadingImage] = useState(false);

  const onLoadedError = () => setErrorLoadingImage(true);

  if (errorLoadingImage && isShow) {
    return (
      <Icon
        icon="no_photography"
        className="absolute inset-0 flex size-full items-center justify-center opacity-20"
      />
    );
  }

  return (
    <>
      <Image
        src={src}
        width={430}
        height={430}
        alt=""
        priority
        className={cn(
          "pointer-events-none absolute size-full object-cover blur-md",
          !isShow && "pointer-events-none hide",
        )}
      />
      <Image
        src={src}
        width={430}
        height={430}
        alt=""
        priority
        className={cn(
          "relative size-full object-contain",
          !isShow && "pointer-events-none hide",
        )}
        onError={onLoadedError}
      />
    </>
  );
};
